import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { clearCatalogCache } from '../api/catalogApi';

function SpeechMark() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" className="brand-mark">
      <path
        d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H9l-5 4V5.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M8 8.5h8M8 11.5h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

/**
 * Global header. There is no signed-out state to render — the whole app is
 * behind ProtectedRoute — so this only ever shows the user menu.
 */
export default function SiteHeader() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const userRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onOutside(e: MouseEvent) {
      if (userRef.current && !userRef.current.contains(e.target as Node)) setMenuOpen(false);
    }
    document.addEventListener('mousedown', onOutside);
    return () => document.removeEventListener('mousedown', onOutside);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSignOut = () => {
    // The catalog cache is keyed by id, not by user — dropping it on sign-out
    // keeps one account's content out of the next account's session.
    clearCatalogCache();
    logout();
    setMenuOpen(false);
  };

  return (
    <nav className="app-nav">
      <Link to="/" className="app-nav-brand">
        <SpeechMark />
        Language Lab
      </Link>

      <div ref={userRef} className="app-nav-user">
        <button type="button" className="user-button" onClick={() => setMenuOpen((v) => !v)}>
          <span className="user-avatar" aria-hidden="true">
            {(user?.displayName ?? '?').charAt(0).toUpperCase()}
          </span>
          <span className="user-name">{user?.displayName}</span>
          <span className="user-caret" aria-hidden="true">
            {menuOpen ? '▴' : '▾'}
          </span>
        </button>
        {menuOpen && (
          <div className="dropdown">
            <Link to="/profile" onClick={() => setMenuOpen(false)} className="dropdown-item">
              Profile &amp; card setup
            </Link>
            <button
              type="button"
              className="dropdown-item dropdown-item--button"
              onClick={handleSignOut}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
